module.exports = __webpack_public_path__ + "img/image-style-01.3b930736.svg";